import React, { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import LoginForm from '../components/LoginForm'
import RegisterForm from '../components/RegisterForm'
import '../styles/auth.css'

const AuthScreen = () => {
  const [searchParams] = useSearchParams()
  const [isLogin, setIsLogin] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    // Check URL parameters to determine initial state
    const mode = searchParams.get('mode')
    const from = searchParams.get('from')
    
    if (mode === 'login') {
      setIsLogin(true)
    } else if (mode === 'register' || from === 'onboarding') {
      setIsLogin(false)
    }
  }, [searchParams])

  const handleAuthSuccess = () => {
    // Redirect to dashboard after successful auth
    navigate('/dashboard')
  }

  const switchToRegister = () => {
    setIsLogin(false)
  }

  const switchToLogin = () => {
    setIsLogin(true)
  }

  return (
    <div className="auth-screen">
      <div className="auth-container">
        <div className="auth-logo">
          <h1>🎯 SurviveIt</h1>
          <p className="tagline">Master the Art of Survival</p>
        </div>
        
        <div className="auth-content">
          {isLogin ? (
            <LoginForm 
              onSwitchToRegister={switchToRegister}
              onSuccess={handleAuthSuccess}
            />
          ) : (
            <RegisterForm 
              onSwitchToLogin={switchToLogin}
              onSuccess={handleAuthSuccess}
            />
          )}
        </div>
        
        <div className="auth-footer">
          <p>© 2024 SurviveIt. Learn. Prepare. Survive.</p>
        </div>
      </div>
    </div>
  )
}

export default AuthScreen